import {Operator, Workflow} from "@/model/Workflow";
import {OperatorTypeEnum} from "@/model/Workflow";

const patchOperatorRemoval = (
    operator: Operator,
    targetOperatorId: string
): Operator => {
    if (operator.type === OperatorTypeEnum.BRANCH_PYTHON){
        if (!Object.values(operator.branchMap).includes(targetOperatorId))
            return operator;

        return {
            ...operator,
            branchMap: Object.fromEntries(
                Object
                    .entries(operator.branchMap)
                    .filter(([_, nextOperatorId]) => nextOperatorId !== targetOperatorId)
            )
        };
    }

    if (operator.type === OperatorTypeEnum.FAN_OUT){
        if(!operator.nextOperatorIds.includes(targetOperatorId))
            return operator;

        return {
            ...operator,
            nextOperatorIds: operator.nextOperatorIds.filter(operatorId => operatorId !== targetOperatorId)
        };
    }

    if (operator.nextOperatorId === targetOperatorId)
        return {...operator, nextOperatorId: undefined};

    return operator;
}

export const removeOperator = (
    workflow: Workflow,
    targetOperatorId: string,
): Workflow => {
    const patchedOperators = Object.fromEntries(
        Object
            .values(workflow.operators)
            .filter(operator => operator._id !== targetOperatorId)
            .map(operator => [operator._id, patchOperatorRemoval(operator, targetOperatorId)])
    );

    return {
        ...workflow,
        operators: patchedOperators
    };
}
